import { FieldMap } from '../../../types/forms/fields'
import { chiefComplaintField } from './shared'

export const wellWomanExamField: FieldMap = {
  name: 'Encounter',
  children: {
    chiefComplaint: chiefComplaintField,
  },
}
